import {cva} from 'class-variance-authority'

/**
 * Alert (v3, MUI-aligned). `severity` × `style`.
 * - `light` — tinted background, colored text + icon.
 * - `dark` — solid color background, white text + icon.
 *
 * Colors are the alert-specific component tokens from Figma (tints/solids differ
 * slightly from the global palette), so they're inlined here.
 */
export const AlertVariantsFactory = cva('flex min-w-[270px] gap-2 rounded-lg p-2 font-sans', {
  variants: {
    severity: {
      info: '',
      success: '',
      warning: '',
      error: '',
      flagged: '',
      cta: '',
    },
    variant: {
      standard: '',
      filled: 'text-white',
    },
  },
  compoundVariants: [
    // standard = tint background + colored content. The backgrounds are the
    // `<severity>-background` rung (Figma `_components/alert/<severity>/background`),
    // which the calendar shift tile also uses for its hover fill — these were
    // hardcoded hexes here until that second consumer made them worth naming.
    {severity: 'info', variant: 'standard', class: 'bg-info-background text-[#00bacc]'},
    {severity: 'success', variant: 'standard', class: 'bg-success-background text-[#53b529]'},
    {severity: 'warning', variant: 'standard', class: 'bg-warning-background text-[#f79600]'},
    {severity: 'error', variant: 'standard', class: 'bg-error-background text-[#d00019]'},
    {severity: 'flagged', variant: 'standard', class: 'bg-flagged-background text-[#ff1aa2]'},
    {severity: 'cta', variant: 'standard', class: 'bg-cta-background text-[#2adbaa]'},
    // filled = solid background + white content (text-white from `style`)
    {severity: 'info', variant: 'filled', class: 'bg-[#00bacc]'},
    {severity: 'success', variant: 'filled', class: 'bg-[#65d237]'},
    {severity: 'warning', variant: 'filled', class: 'bg-[#f7a900]'},
    {severity: 'error', variant: 'filled', class: 'bg-[#d00019]'},
    {severity: 'flagged', variant: 'filled', class: 'bg-[#ff1aa2]'},
    {severity: 'cta', variant: 'filled', class: 'bg-[#2adbaa]'},
  ],
  defaultVariants: {
    severity: 'info',
    variant: 'standard',
  },
})
